import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from 'actions'

class Question extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAnswer: props.id === 1
    }
  }
  toggleAnswer = () => {
    let {id, dispatch} = this.props
    dispatch(actions.token.toggleAnswer(id))
  }
  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.questionId === 'undefined') {
      this.setState({data: nextProps.data})
    } else {
      this.setState({
        data: nextProps.data,
        showAnswer: this.props.id === nextProps.questionId
      })
    }
  }
  render() {
    let answer, fontWeight, answerClass = 'answer', questionClass = 'question'
    if (this.state && this.state.showAnswer) {
      answerClass = 'active-answer fade-in'
      answer = <p className={answerClass}>{this.props.answer}</p>
      questionClass = 'question question-active active'
    }

    return (
      <div>
        <h4 onClick={this.toggleAnswer} className={questionClass}>{this.props.question}</h4>
        {answer}
        <br></br>
        <br></br>
      </div>
    )
  }
}
Question.contextTypes = {
}
Question.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    data: state.token.data,
    questionId: state.token.questionId
  }
}

export default connect(mapStateToProps)(Question)



// WEBPACK FOOTER //
// ./src/components/Utils/Question.js